<template>
  <div>
    <div class="col-12">
      <i class="fas fa-map-marked-alt fa-2x c-orange mr-2"></i>
      <h4 class="text-uppercase c-orange font-weight-bold d-inline">
        Endereço
      </h4>
      <div class="row mt-3">
        <div class="form-group col-md-3 col-6">
          <label for="cep" class="font-weight-bold"> CEP: </label>
          <input
            type="text"
            class="form-control"
            id="cep"
            name="cep"
            v-model="Fields.partner.cep"
            v-mask="'#####-###'"
            @input="ErrorMessages.cep = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.cep !== null"
          >
            {{ ErrorMessages.cep }}
          </p>
        </div>
        <div class="form-group col-md-9 col-6">
          <label for="endereco" class="font-weight-bold"> Endereço: </label>
          <input
            type="text"
            class="form-control"
            id="endereco"
            name="endereco"
            v-model="Fields.partner.endereco"
            @input="ErrorMessages.address = null"
            :disabled="
              !cepConsult.consulted ||
              (cepConsult.consulted && cepConsult.isValidAddress)
            "
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.address !== null"
          >
            {{ ErrorMessages.address }}
          </p>
        </div>
        <div class="form-group col-md-3 col-6">
          <label for="numero" class="font-weight-bold"> Número: </label>
          <input
            type="text"
            class="form-control"
            id="numero"
            name="numero"
            v-model="Fields.partner.numero"
            @input="ErrorMessages.number = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.number !== null"
          >
            {{ ErrorMessages.number }}
          </p>
        </div>
        <div class="form-group col-md-3 col-6">
          <label for="bairro" class="font-weight-bold"> Bairro: </label>
          <input
            type="text"
            class="form-control"
            id="bairro"
            name="bairro"
            v-model="Fields.partner.bairro"
            @input="ErrorMessages.neighborhood = null"
            :disabled="
              !cepConsult.consulted ||
              (cepConsult.consulted && cepConsult.isValidNeighborhood)
            "
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.neighborhood !== null"
          >
            {{ ErrorMessages.neighborhood }}
          </p>
        </div>
        <div class="form-group col-6">
          <label for="complemento" class="font-weight-bold">
            Complemento:
          </label>
          <input
            type="text"
            class="form-control"
            id="complemento"
            name="complemento"
            v-model="Fields.partner.complemento"
            @input="ErrorMessages.complement = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.complement !== null"
          >
            {{ ErrorMessages.complement }}
          </p>
        </div>
        <div class="form-group col-6">
          <label for="cidade" class="font-weight-bold"> Cidade: </label>
          <v-select
            id="cidade"
            label="nome"
            name="cidade"
            :key="Fields.partner.cidade_id"
            :options="getCities"
            :reduce="(city) => city.id"
            v-model="Fields.partner.cidade_id"
            disabled
            @input="ErrorMessages.city = null"
          >
            <div slot="no-options">Não encontrou nada.</div>
          </v-select>
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.city_id !== null"
          >
            {{ ErrorMessages.city_id }}
          </p>
        </div>
        <div class="form-group col-6">
          <label for="estado_id" class="font-weight-bold"> Estado: </label>
          <v-select
            id="estado_id"
            label="estado_id"
            name="estado_id"
            :key="Fields.partner.estado_id"
            v-model="Fields.partner.estado_id"
            disabled
            @input="ErrorMessages.estado_id = null"
          >
            <div slot="no-options">Não encontrou nada.</div>
          </v-select>
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.estado_id !== null"
          >
            {{ ErrorMessages.estado_id }}
          </p>
        </div>
      </div>
      <button
        @click="updateAddressInformation()"
        type="submit"
        class="btn bg-success text-white my-3 text-uppercase"
      >
        Atualizar Endereço
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import userTypes from '../../enums/UserTypes';
import makeToast from '../../mixins/makeToast';

export default {
  // props: {
  //   userId: {
  //     required: true,
  //   },
  //   userType: {
  //     required: true,
  //   },
  // },
  mixins: [makeToast],
  created() {
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('startLoader');
    this.get(this.dadosUsuario.informacoes.id)
      .then(() => {
        this.Fields.partner = this.getPartner;
      })
      .finally(() => this.$store.dispatch('endLoader'));
  },
  data() {
    return {
      userTypes,
      Fields: {
        partner: {},
      },
      ErrorMessages: {
        address: null,
        number: null,
        cep: null,
        neighborhood: null,
        city_id: null,
        estado_id: null,
        complement: null,
      },
      cepConsult: {
        consulted: false,
        isValidAddress: true,
        isValidNeighborhood: true,
      },
      loading: false,
    };
  },
  computed: {
    ...mapState(['dadosUsuario', 'cidades']),
    ...mapGetters('general', ['getCities']),
    ...mapGetters('partner', ['getPartner']),
  },
  watch: {
    'Fields.partner.cep': function () {
      this.consultCep();
    },
  },
  mounted() {
    this.getAllCities();
  },
  methods: {
    ...mapActions('general', ['getAllCities']),
    ...mapActions('partner', ['get', 'updateTelephones', 'updateAddress']),
    validateAddress() {
      let isValid = true;

      if (!this.Fields.partner.bairro) {
        this.ErrorMessages.neighborhood = 'Você não preencheu o bairro';
        isValid = false;
      }

      if (!this.Fields.partner.cidade) {
        this.ErrorMessages.city = 'Você não selecionou nenhuma cidade';
        isValid = false;
      }

      if (!this.Fields.partner.cep) {
        this.ErrorMessages.cep = 'Você não preencheu o CEP';
        isValid = false;
      }

      if (!this.Fields.partner.numero) {
        this.ErrorMessages.number = 'Você não preencheu o número';
        isValid = false;
      }

      if (!this.Fields.partner.endereco) {
        this.ErrorMessages.address = 'Você não preencheu o endereço';
        isValid = false;
      }

      if (!this.Fields.partner.estado_id) {
        this.ErrorMessages.estado_id = 'Você não preencheu o estado';
        isValid = false;
      }

      if (
        this.Fields.partner.complemento !== null &&
        this.Fields.partner.complemento !== '' &&
        !this.Fields.partner.complemento
      ) {
        this.ErrorMessages.complement = 'Complemento inválido';
        isValid = true;
      }

      return isValid;
    },
    updateAddressInformation() {
      if (this.validateAddress()) {
        this.$store.dispatch('startLoader');

        const data = {
          userId: this.Fields.partner.usuario_id,
          neighborhood: this.Fields.partner.bairro,
          city: this.Fields.partner.cidade_id,
          cep: this.Fields.partner.cep,
          complement: this.Fields.partner.complemento,
          number: this.Fields.partner.numero,
          address: this.Fields.partner.endereco,
          estado_id: this.Fields.partner.estado_id,
        };

        this.updateAddress(data)
          .then((response) => {
            this.makeToast('Sucesso!', response.data.message);
          })
          .catch((error) => {
            this.makeToast('Oops!', error.response.data.message, 'danger');
          })
          .finally(() => this.$store.dispatch('endLoader'));
      }
    },
    consultCep() {
      if (!this.loading && this.Fields.partner.cep.length === 9) {
        this.loading = true;
        this.$store.dispatch('startLoader');

        this.$store
          .dispatch('user/consultCep', this.Fields.partner.cep)
          .then(async (response) => {
            this.validateCepResults(response.data);
          })
          .catch((error) => {
            this.makeToast('Oopss!', error.response.data.message, 'danger');
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch('endLoader');
          });
      }

      if (this.Fields.partner.cep.length === 0) {
        this.cepConsult.consulted = false;
        this.Fields.partner.endereco = null;
        this.Fields.partner.bairro = null;
        this.Fields.partner.cidade_id = null;
        this.Fields.partner.estado_id = null;
      }
    },
    validateCepResults(result) {
      this.cepConsult.consulted = true;

      this.cepConsult.isValidAddress = !!result.logradouro;

      this.cepConsult.isValidNeighborhood = !!result.bairro;

      this.Fields.partner.endereco = result.logradouro || null;
      this.Fields.partner.bairro = result.bairro || null;
      this.Fields.partner.cidade_id = result.cidade_id || null;
      this.Fields.partner.estado_id = result.uf || null;

      this.ErrorMessages.address = null;
      this.ErrorMessages.neighborhood = null;
      this.ErrorMessages.city_id = null;
      this.ErrorMessages.estado_id = null;
    },
  },
};
</script>
